import { Guid } from "guid-typescript";

export class LaboratoryIndicatorExaminationMethodDto {

    laboratoryIndicatorExaminationMethodId: number;
	laboratoryIndicatorId: number;
	laboratoryIndicatorName: string;
	laboratoryExaminationMethodId: number;
	laboratoryExaminationEquipmentId: number;
	accuracy: number;
	inaccuracy: number;
	normalValueMax: number;
	normalValueMin: number;
	isDefault: boolean;
	uuid: string;
}